import React, { useEffect } from 'react';
import { useTitle } from "../../../contexts/title";
import InactiveUserGrid from '../../../features/common/inactive-user-grid/components/InactiveUserGrid';

export default function InactiveUsersPage() {

	const pageTitle = useTitle();
	useEffect(() => {
		pageTitle.setTitle('Inactive Users')
	}, [pageTitle]);

	return (
		<React.Fragment>
			<div className={'content-block'}>
				<InactiveUserGrid />
			</div>
		</React.Fragment>
	)
} 
